<template>
  <ul class="ml-6 list-disc [&:not(:first-child)]:mt-6 [&:not(:last-child)]:mb-6 [&>li:not(:first-child)]:mt-2">
    <slot />
  </ul>
</template>
